import React from "react";
import { Col, Row } from "react-bootstrap";
import Logo from "../assets/images/generic/nuvama_name_logo.png";
import "../stylesheets/components/HeaderLogoIcon.scss";
import { Link } from "react-router-dom";
var HeaderLogoIcon = function (props) {
    return (React.createElement(Row, { className: "logo-icons alignCenter ".concat(props.className ? props.className : "") },
        React.createElement(Col, { xl: 7, lg: 6, className: "ps-0" },
            React.createElement(Col, null,
                React.createElement("div", { className: "logo" },
                    React.createElement(Link, { to: props.linkOfLogo ? props.linkOfLogo : "" },
                        React.createElement("img", { src: Logo, alt: "nuvama", width: 150 })))),
            props.children ? props.children : ""),
        React.createElement(Col, { xl: 5, lg: 6 },
            React.createElement("div", { className: "d-flex justify-content-end" },
                React.createElement("div", { className: "pe-4" },
                    React.createElement(Row, { className: "m-0 txt_grey DMSanM_14_500 pb-1" }, props.profileName),
                    React.createElement(Row, { className: "m-0 Roboto_11_400 txt_primaryGrey" }, props.profileAddress)),
                React.createElement("div", { className: "ps-0" }, props.iconChildren)))));
};
export default HeaderLogoIcon;
